import * as React from 'react'
import { ReactElement } from 'react'
import NoteList, { NoteListProps } from '../../components/List/Note/NoteList'

type Props = { baseUrl: string } & NoteListProps

export default function NoteOverview(props: Props): ReactElement {
    return <NoteList {...props} />
}
